<script lang='ts'>
import { defineComponent, reactive, computed } from '@vue/composition-api';
import { useNotificationSettingsStore } from '@/store/global/notification-settings';

const PlatformIcons = defineComponent({
    name: 'PlatformIcons',
    setup() {
        const store = useNotificationSettingsStore();

        const state = reactive({
            slackIsConnected: computed(() => store.state.slackIsConnected),
        });

        return {
            state,
        };
    },
});

export default PlatformIcons;
</script>

<template>
  <div class="d-flex">
    <v-tooltip top open-delay="300">
      <template #activator="{ on }">
        <v-icon
          color="primary100"
          class="px-1 mr-2"
          size="27"
          v-on="on"
        >
          $farBell
        </v-icon>
      </template>
      <span>In-app notification</span>
    </v-tooltip>
    <v-tooltip v-if="state.slackIsConnected" top open-delay="300">
      <template #activator="{ on }">
        <v-icon
          color="primary100"
          class="px-1 mr-2"
          size="27"
          v-on="on"
        >
          $fabSlack
        </v-icon>
      </template>
      <span>Slack notification</span>
    </v-tooltip>
    <v-tooltip top open-delay="300">
      <template #activator="{ on }">
        <v-icon
          color="primary100"
          class="px-1 mr-2"
          size="27"
          v-on="on"
        >
          $farEnvelope
        </v-icon>
      </template>
      <span>Email notification</span>
    </v-tooltip>
  </div>
</template>